import { createFileRoute } from "@tanstack/react-router";

import { EnterpriseMemberDetailPage } from "@/features/enterprise/member-detail-page";
import { memberDetailQueryOptions } from "@/features/enterprise/queries";
import { memberOrgNameCrumb } from "@/lib/crumb-resolvers";

// ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
// `members` は静的セグメントなので、案件詳細 (`/enterprise/$id`) より優先してマッチする。
export const Route = createFileRoute("/_authenticated/enterprise/members/$id/")({
  staticData: { crumb: memberOrgNameCrumb() },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(memberDetailQueryOptions(params.id)),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <EnterpriseMemberDetailPage orgId={id} />;
}
